import React from 'react';
import { Button, Row, Col, Modal, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { setConfig } from 'reducers/configReducer';
import TeamMembers from './TeamMembers';

const SplashScreen = ({ show, onClose }) => {
  const { showSplashAtLogin } = useSelector(state => state.config);
  const dispatch = useDispatch();
  const handleClose = () => {
    onClose();
  };

  const handleCheck = e => {
    dispatch(setConfig({ key: 'showSplashAtLogin', value: e.target.checked }));
  };

  return (
    <>
      <Modal show={show} size="xl">
        <Modal.Body>
          <TeamMembers />
        </Modal.Body>
        <Modal.Footer>
          <Form>
            <Row className="align-items-center g-3">
              <Col>
                <Form.Check
                  type="checkbox"
                  label="Show splash screen at login"
                  className="mb-0"
                  defaultChecked={showSplashAtLogin}
                  onClick={handleCheck}
                />
              </Col>
              <Col xs="auto">
                <Button
                  variant="outline-secondary"
                  onClick={handleClose}
                  className="mb-2"
                >
                  Close
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Footer>
      </Modal>
    </>
  );
};

SplashScreen.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default SplashScreen;
